// extracted by mini-css-extract-plugin
module.exports = {"title":"SignUp_title__2Fuze","description":"SignUp_description__3A5Lh","link":"SignUp_link__2iHxd","error":"SignUp_error__A8cmn"};